import { anyPass, ifElse, isEmpty, isNil, prop } from 'ramda';

interface IHasNoItems {
  <T extends ReadonlyArray<any>>(array: Optional<T>): array is undefined | null;
  <T extends any[]>(array: Optional<T>): array is undefined | null;
}
/**
 * 주어진 배열이 nil이거나 비어있는지 여부를 판별한다. MobX 배열에도 사용할 수 있다.
 * @param array 판별할 배열.
 * @return nil이거나 비어있으면 `true`, 아니면 `false`.
 */
export const hasNoItems = ifElse(prop('$mobx'), array => !array.length, anyPass([isNil, isEmpty])) as IHasNoItems;
